import tonStyles from './../ton.json'

export default {
  name: '1',
  type: 'Label',
  default: {
    color: tonStyles.colors.SecondaryGrey,
    borderBottom: `1px solid ${tonStyles.colors.SecondaryGrey}`
  },
  hover: {
    color: tonStyles.colors.SecondaryLightGrey,
    borderBottom: `1px solid ${tonStyles.colors.SecondaryLightGrey}`
  },
  disabled: {
    color: tonStyles.colors.PrimaryGrey,
    borderBottom: `1px solid ${tonStyles.colors.PrimaryGrey}`
  }
}
